document.addEventListener('click', (event) => {
  const control = event.target.closest('[data-aw-carousel-step]');
  if (!control) return;
  const rail = control.closest('.aw-diffuser-upsell')?.querySelector('[data-aw-diffuser-rail]');
  if (!rail) return;
  const card = rail.querySelector('.aw-diffuser-upsell__card');
  const distance = card ? card.getBoundingClientRect().width + 14 : rail.clientWidth * .75;
  rail.scrollBy({ left: distance * Number(control.dataset.awCarouselStep), behavior: 'smooth' });
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('form[data-aw-diffuser-form]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  const status = form.closest('.aw-diffuser-upsell')?.querySelector('.aw-diffuser-upsell__status');
  if (button.disabled) return;
  button.disabled = true;
  try {
    const url = new URL(form.action);
    url.pathname = url.pathname.replace(/\/$/, '') + '.js';
    const response = await fetch(url, {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json' }
    });
    if (!response.ok) throw new Error('Cart add failed');
    if (status) status.textContent = form.closest('.aw-diffuser-upsell')?.dataset.successMessage || '';
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: !!form.closest('m-cart-drawer') || !!form.closest('[data-aw-open-cart]') } }));
  } catch (error) {
    if (status) status.textContent = form.closest('.aw-diffuser-upsell')?.dataset.errorMessage || '';
    button.disabled = false;
  }
});
